<a class="button {{class}}" [ngClass]="{'disabled': disable}" (click)="onClick.emit($event)">
    <i *ngIf="icon" [class]="icon + ' ' +iconPlace"></i>
    <span class="label">{{ label | translate }}</span>
    <div *ngIf="!!badge" class="number">
        <span>{{ badge }}</span>
    </div>
</a>
